// extracted by mini-css-extract-plugin
export default {"header":"cew80aJsF","ship":"cWp3VgznD","waves":"cKoBL8krz","innerHeader":"cCnptUgTb","formContainer":"cp0pwkM6P"};